import { AppConfig } from '../domain/config'

export const SOCURE_MODULE_URL = 'https://js.dvnfo.com/devicer.min.js'

export const SOCURE_SESSION_DATA = 'devicer_id'

/**
 * Currently mirroring iOS, generating the `deviceSessionId`
 * on application submission via `sendData` (although the
 * iOS app does not include `context`).
 *
 * Note: `context` can be any string, and this can be
 * expanded to capture/send data to Socure at any other
 * points we see fit (i.e. homepage, login, etc.)
 */
export type SocureDeviceContext = 'application submission'

export type SocureDeviceOptions = {
  publicKey: string
  userConsent: boolean
  context: SocureDeviceContext
}

export type SocureConfigs = {
  config: AppConfig
  context: SocureDeviceContext
}

export type SocureSessionData = {
  timestamp: number
  value: string
}
